import { PublicClientApplication } from "@azure/msal-browser";
import config from "../config/config";

/**
 * Helper function to return authentication token
 * @returns Microsoft OAUTH Authentication Token, or null when nobody is signed in
 */

async function getToken(){
    const msalInstance = new PublicClientApplication({
      auth: {
        clientId: config.clientID,
        authority: `https://login.microsoftonline.com/${config.tenantID}`,
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
      },
    });
    const activeAccount = msalInstance.getActiveAccount(); 
    const accounts = msalInstance.getAllAccounts();
    
    if (!activeAccount && accounts.length === 0) {
        /*
        * User is not signed in. Throw error or wait for user to login.
        * Do not attempt to log a user in outside of the context of MsalProvider
        */   
       return null
    }
    const request = {
        scopes: ["api://83b8a045-a14d-459b-82a0-ea2e6bfe20f0/azuread.scope"],
        account: activeAccount || accounts[0]
    };
    
    const authResult = await msalInstance.acquireTokenSilent(request);
    
    return `Bearer ${authResult.accessToken}`
  }

// Students have no account to get a token from, but API Gateway will not invoke
// the authorizer at all unless the header is present, so signed-out callers send
// this placeholder. The authorizer allows it only on the student routes.
export const ANONYMOUS_AUTHORIZATION = "Bearer anonymous";

/**
 * Builds request headers with an authorization value that is always a real
 * string. Sending `undefined` here is what the authorizer rejected as a 403.
 */
export async function authHeaders(extraHeaders = {}) {
  let token = null;

  try {
    token = await getToken();
  } catch (error) {
    console.log("Could not acquire a token silently: ", error);
  }

  return { ...extraHeaders, authorization: token || ANONYMOUS_AUTHORIZATION };
}

export default getToken